import { titleColor } from './common'

export default data => {
  const dataSource = [['shop_name', 'amount']].concat(data.map(i => [i.x, i.y]))
  console.log('source', dataSource)
  return {
    title: {
      text: '当月销售额排名',
      textStyle: {
        color: titleColor,
        fontSize: 30,
        fontWeight: 'bold'
      }
    },
    grid: {
      left: '20%',
      bottom: '5%',
      right: '15%',
      top: '10%'
    },
    textStyle: {
      color: '#fff'
    },
    dataset: {
      source: dataSource
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    xAxis: {
      type: 'value',
      name: '销量',
      axisLabel: {
        fontSize: 20,
        fontWeight: 'bold'
      },
      nameTextStyle: {
        fontSize: 20,
        fontWeight: 'bold'
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: '#142346'
        }
      }
    },
    yAxis: {
      type: 'category',
      name: '店铺',
      axisLabel: {
        fontSize: 20,
        fontWeight: 'bold'
      },
      nameTextStyle: {
        fontSize: 20,
        fontWeight: 'bold'
      }
    },
    series: [
      {
        type: 'bar',
        barMaxWidth: '40',
        label: {
          show: true,
          fontSize: 20
        },
        itemStyle: {
          fontSize: 20,
          fontWeight: 'bold'
        },
        encode: {
          x: 'amount',
          y: 'shop_name'
        }
      }
    ]
  }
}
